<lla-date-picker
  [value]="data.selectedValue"
  [maxDate]="data.maxDate"
  [minDate]="data.minDate"
  [label]="data.label"
  (valueChanged)="dialogRef.close($event)"
  (cancelled)="dialogRef.close()"
></lla-date-picker>
